import React from 'react';
import { SoundEffectsController } from './definitions';

export const SoundEffectsContext = React.createContext<SoundEffectsController>({} as SoundEffectsController);
export default SoundEffectsContext;
